import React from "react";
import ReactDOM from "react-dom";

import BrandOfTheMonthModal from "./BrandOfTheMonthModal/BrandOfTheMonthModal";

const BrandOfTheMonthModalPortal: React.FC = () => {
  const bodyElement = document.querySelector("body");
  const categoryId = bodyElement?.id;

  if (categoryId !== "C133768" || !bodyElement) {
    return null;
  }

  const divElement = document.createElement("div");
  bodyElement.appendChild(divElement);

  return ReactDOM.createPortal(<BrandOfTheMonthModal />, divElement);
};

export default BrandOfTheMonthModalPortal;
